import React, { useState, useRef } from 'react';
import './App.css';
import Div100vh from 'react-div-100vh';

function App() {

  const [isConnected, setIsConnected] = useState(false);
  const remoteAudioRef = useRef<HTMLAudioElement | null>(null);
  const peerConnectionRef = useRef<RTCPeerConnection | null>(null);
  const dataChannelRef = useRef<RTCDataChannel | null>(null);

  const startSession = async () => {
    try {
      // Get an ephemeral key from your server
      // const tokenResponse = await fetch("/session");
      // const data = await tokenResponse.json();
      // const EPHEMERAL_KEY = data.client_secret.value;

      const EPHEMERAL_KEY = "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";

      const pc = new RTCPeerConnection();
      peerConnectionRef.current = pc;

      pc.ontrack = (event) => {
        console.log("Received remote audio track:", event);
        if (remoteAudioRef.current) {
          console.log("Setting remote audio source:", event.streams[0]);
          remoteAudioRef.current.srcObject = event.streams[0];
        }
      };

      const mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
      pc.addTrack(mediaStream.getTracks()[0]);

      const dc = pc.createDataChannel("oai-events");
      dataChannelRef.current = dc;
      dc.addEventListener("message", (event) => {
        console.log("Realtime server event:", event.data);
      });
      dc.onopen = () => {
        const event = {
          type: "session.update",
          session: {
            instructions: "You are a helpful assistant. On default you speak in Polish.",
          },
        };
        dc.send(JSON.stringify(event));
      };

      const offer = await pc.createOffer();
      await pc.setLocalDescription(offer);

      const baseUrl = "https://api.openai.com/v1/realtime";
      const model = "gpt-4o-realtime-preview-2024-12-17";

      const sdpResponse = await fetch(`${baseUrl}?model=${model}`, {
        method: "POST",
        body: offer.sdp,
        headers: {
          Authorization: `Bearer ${EPHEMERAL_KEY}`,
          "Content-Type": "application/sdp",
        },
      });

      const answer: RTCSessionDescriptionInit = {
        type: "answer",
        sdp: await sdpResponse.text(),
      };
      await pc.setRemoteDescription(answer);

      setIsConnected(true);
    } catch (error) {
      console.error("Error starting the WebRTC session:", error);
    }
  };

  const disconnectSession = () => {
    try {
      if (dataChannelRef.current) {
        dataChannelRef.current.close();
        dataChannelRef.current = null;
      }


      if (peerConnectionRef.current) {
        peerConnectionRef.current.close();
        peerConnectionRef.current = null;
      }

      if (remoteAudioRef.current) {
        remoteAudioRef.current.srcObject = null;
      }

      setIsConnected(false);
      console.log("Disconnected and resources cleaned up.");
    } catch (error) {
      console.error("Error disconnecting the session:", error);
    }
  };

  return (
    <div className="App">
      <Div100vh className="App-header">
        <p>Chatporter Assistant</p>
        <div
          onClick={isConnected ? disconnectSession : startSession}
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            backgroundColor: isConnected ? "#db312a" : "#9b2adb",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            cursor: "pointer",
            color: "white",
            fontSize: "18px",
            animation: isConnected ? "pulse 1.5s infinite" : "none",
          }}
        >
          {isConnected ? "Stop" : "Start"}
        </div>
        <audio ref={remoteAudioRef} autoPlay />
      </Div100vh>
    </div>

  );
};
export default App;
